import { render } from "./historyDialog.vue?vue&type=template&id=c603185c&scoped=true"
import script from "./historyDialog.vue?vue&type=script&lang=js"
export * from "./historyDialog.vue?vue&type=script&lang=js"

import "./historyDialog.vue?vue&type=style&index=0&id=c603185c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c603185c"

export default script